import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import "./PolicyNav.scss";

class PolicyNav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onPolicyNavSelect: "",
      policyNavLinks: [
        "Overview",
        "Land Use",
        "Fiscal",
        "Pedestrians",
        "Cars",
        "Buses",
        "Trains",
        "Bicycles",
        "Engagement"
      ]
    };
  }

  //TODO:  If user navigates to Engagement screen, and selects a policy, but does not submit the policy, should we prevent them from navigating away to another policy screen?  If so, the TODO is to introduce logic that says, if state.engagementsuspended is false && there is a current policy selected && the current policy screen is "Engagement", two things should happen, we should flash a warning alert that says, please submit engagement policy or deselect policy in order to proceed. 2nd thing is to stop navigation while this is happening.

  componentWillReceiveProps() {
    const url = window.location.href.split("/")[6];
    // console.log("Inside policyNav")
    if (url) {
      this.setState({
        onPolicyNavSelect:
          url.charAt(0).toUpperCase() +
          window.location.href.split("/")[6].substring(1)
      });
    }
  }
//for the yellow border to show what is selected
  onPolicyNavSelect(policy) {
    this.setState({ onPolicyNavSelect: policy });
  }

  render() {
    let districtMetricsName;
    switch (this.props.districtName) {
      case "Downtown":
        districtMetricsName = "Downtown";
        break;
      case "Corbusville":
        districtMetricsName = "Corbusville";
        break;
      case "Moses Gulch":
        districtMetricsName = "MosesGulch";
        break;
      case "Jacobs Hill":
        districtMetricsName = "JacobsHill";
        break;
      case "Howard Gardens":
        districtMetricsName = "HowardGardens";
        break;
      default:
        break;
    }
    return (
      <div className="polNav flex flex-justify-center flex-items-center">
        <ul>
          {this.state.policyNavLinks.map((policy, index) => (
            <li key={index}>
                {this.props.policyHeader === policy ? (
                              //   <ReactCSSTransitionGroup
                              //   transitionName="fade"
                              //   transitionAppear={true}
                              //   transitionAppearTimeout={500}
                              //   transitionEnterTimeout={500}
                              //   transitionLeaveTimeout={300}
                              // >
                
                  <Link
                    className="linkBorder"
                    to={
                      "/game/district/" +
                      window.location.href.split("/")[5] +
                      "/" +
                      policy.toLowerCase()
                    }
                    onClick={e => {
                      this.props.onNavSelect(policy);
                      this.onPolicyNavSelect(policy);
                    }}
                    style={
                      policy === "Land Use" && this.props.Commercial +
                      this.props.Green +
                      this.props.Mixed +
                      this.props.Residential +
                      this.props.parkingZone[districtMetricsName] !== 100
                        ? { color: "red" }
                        : { color: "#596773" }
                    }
                  >
                    {policy}
                  </Link>
                  // </ReactCSSTransitionGroup>
                ) : (
                  <Link
                    className="nolinkBorder"
                    to={
                      "/game/district/" +
                      window.location.href.split("/")[5] +
                      "/" +
                      policy.toLowerCase()
                    }
                    onClick={e => {
                      this.props.onNavSelect(policy);
                      this.onPolicyNavSelect(policy);
                    }}
                    style={
                      policy === "Land Use" && this.props.Commercial +
                      this.props.Green +
                      this.props.Mixed +
                      this.props.Residential +
                      this.props.parkingZone[districtMetricsName] !== 100
                        ? { color: "red" }
                        : { color: "#596773" }
                    }
                  >
                    {policy}
                  </Link>
                )}
              
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default withRouter(PolicyNav);
